package org.multiplatform.kotfolio.pages

import androidx.compose.runtime.*
import org.multiplatform.kotfolio.components.backToTopButton
import org.multiplatform.kotfolio.components.header
import org.multiplatform.kotfolio.components.overflowMenu
import org.multiplatform.kotfolio.sections.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout

@Layout(".layout.PageLayout")
@Page
@Composable
fun homePage() {
    var menuOpened by remember { mutableStateOf(false) }

    mainSection(onMenuClicked = { menuOpened = true })
    skillsSectionV2()
    BlogSection()
    portfolioSectionV2()
    serviceSectionV2()
    testimonialSection()
    aboutMeSection()
    contactSection()
    footerSection()

    // Fixed header overlaid on top of all content
    header(onMenuClicked = { menuOpened = true })

    backToTopButton()

    if (menuOpened) {
        overflowMenu(onMenuClosed = { menuOpened = false })
    }
}

